/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
/**
 * @legacy
 * @alpha
 */
export var MessageType;
(function (MessageType) {
    /**
     * Empty operation message. Used to send an updated reference sequence number.
     * Relay service is free to coalesce these messages or fully drop them, if
     * another message was used to update MSN to a number equal or higher than referenced
     * sequence number in Noop.
     */
    MessageType["NoOp"] = "noop";
    /**
     * System message sent to indicate a new client has joined the collaboration.
     */
    MessageType["ClientJoin"] = "join";
    /**
     * System message sent to indicate a client has left the collaboration.
     */
    MessageType["ClientLeave"] = "leave";
    /**
     * Proposes a new consensus value.
     */
    MessageType["Propose"] = "propose";
    /**
     * Message used to reject a pending proposal.
     */
    MessageType["Reject"] = "reject";
    /**
     * Message sent by client accepting proposal
     */
    MessageType["Accept"] = "accept";
    /**
     * Summary operation (message).
     */
    MessageType["Summarize"] = "summarize";
    /**
     * Summary operation (message) written.
     */
    MessageType["SummaryAck"] = "summaryAck";
    /**
     * Summary operation (message) write failure.
     */
    MessageType["SummaryNack"] = "summaryNack";
    /**
     * Operation (message) produced by container runtime.
     */
    MessageType["Operation"] = "op";
    /**
     * Message to indicate that no active clients are present.
     */
    MessageType["NoClient"] = "noClient";
    /**
     * Message to indicate successful round trip.
     */
    MessageType["RoundTrip"] = "tripComplete";
    /**
     * Service specific control messages that are never sequenced.
     */
    MessageType["Control"] = "control";
})(MessageType || (MessageType = {}));
/**
 * @internal
 */
export var SignalType;
(function (SignalType) {
    /**
     * System signal sent to indicate a new client has joined the collaboration.
     */
    SignalType["ClientJoin"] = "join";
    /**
     * System signal sent to indicate a client has left the collaboration.
     */
    SignalType["ClientLeave"] = "leave";
})(SignalType || (SignalType = {}));
/**
 * Type of the nack.
 * @legacy
 * @alpha
 */
export var NackErrorType;
(function (NackErrorType) {
    /**
     * Retriable after {@link ISummaryNack.retryAfter} seconds.
     */
    NackErrorType["ThrottlingError"] = "ThrottlingError";
    /**
     * Client's token is not valid for the intended message.
     */
    NackErrorType["InvalidScopeError"] = "InvalidScopeError";
    /**
     * Clients message is invalid and should retry immediately with a valid message.
     */
    NackErrorType["BadRequestError"] = "BadRequestError";
    /**
     * Service is having issues. Client should not retry.
     */
    NackErrorType["LimitExceededError"] = "LimitExceededError";
})(NackErrorType || (NackErrorType = {}));
//# sourceMappingURL=protocol.js.map